import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors, Hash } from 'utils';
import { Table, Pagination, Tooltip, Input, DatePicker, Select, Modal } from 'components';
import { CleanIcon, ViewIcon, TrashIcon, WarningIcon, SuccessIcon, Menu as MenuIcons, RestoreIcon, CheckCircle, CloseRedIcon, CloseCircle } from 'assets/icons';
import { ReportService, CompanyService } from 'services';
import moment from 'moment';
import queryString from 'query-string';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_FORM = {
	search: '',
    since: '',
    until: '',
	client_id: '',
	company_id: '',
	client: ''
}

class BillsReport extends React.Component<Props> {

	timer: any = undefined;

	state = {
		header: [
			'Usuario',
			'Nº Factura',
			'Emisor',
			'Fecha Emisión',
			'Fecha Registro',
			'Estado'
		],
		form: INITIAL_FORM,
		data: [],
		page: 1,
		last_page: 1,
		visible: false,
		item: null,
		clients: [],
		verifications_count: 0,
		companies: [],
		default_company: null,
		approved_count: 0,
		rejected_count: 0
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Reporte de Facturas',
				onBack: null,
				subtitle: 'Consulta y revisa todas las facturas realizadas en el sistema.',
				color: '#edf0fe',
				icon: MenuIcons.Menu6
			}
		});

		this.load();
		this.loadCompanies();
		
		if (this.props.user?.level_id == Constants.LEVELS.ADMIN || this.props.user?.level_id == Constants.LEVELS.MODERATOR) {
			this.loadClients();
		}

		if (this.props.user?.level_id == Constants.LEVELS.CLIENT || this.props.user?.level_id == Constants.LEVELS.CLIENT_MODERATOR) {
			let header = [...this.state.header];
			header.shift();
			this.setState({
				header
			});
		}
	}

	loadClients = async () => {
		const res: any = await ReportService.admin.getClients({
			withoutLoading: true
		});
		this.setState({
			clients: res.clients || []
		});
	}

	loadCompanies = async () => {
		const res: any = await CompanyService.admin.get({
			withoutLoading: true
		});
		this.setState({
			companies: res.companies || [],
			default_company: res.default_company
		},() => {
			if (res.companies?.length > 0) {
				let header = this.state.header;
				header.splice(5,0,'Empresa');
				this.setState({
					header
				});
			}
		});
	}

	load = async (withoutLoading: boolean = false,callback = () => {}) => {
		const res: any = await ReportService.admin.bills.getVerifications({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
		});
		this.setState({
			data: res.verifications.rows,
			last_page: res.verifications.count,
			verifications_count: res.verifications_count || 0,
			approved_count: res.approved_count || 0,
			rejected_count: res.rejected_count || 0
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	reset = () => {
		this.setState({
			form: INITIAL_FORM,
			page: 1
		},() => this.load(true));
	}

	view = (item: any) => {
		window.open(window.location.href + '/view/' + Hash.encryptWithAES(item?.id),'_blank');
	}

	getColor = (item: any) => {
		let color = '';

		if (item?.last_verification?.result) {
			return {
				color: '#4eb686',
				secondary_color: '#eafbf3',
				icon: SuccessIcon
			}
		}
		else {
			return {
				color: '#e73a4c',
				secondary_color: '#feeff1',
				icon: CloseRedIcon
			}
		}

		return color;
	}

	render() {
		return (
			<div id="bills-report">
				<div className="row row-filter">
					<div className="col-md-12">
						<div className="row">
							<div className="col-md-12 row">
								<div className="col-md">
									<Input
										value={ this.state.form.search }
										name="search"
										placeholder="Buscar"
										label="Buscar por Nº Factura"
										className="input-table"
										onSubmit={ () => this.load() }
										onChange={ (e: any) => {
											clearTimeout(this.timer);
											this.timer = setTimeout(() => {
												this.load(true);
											},1000);
											this.change(e); 
										} } />
								</div>
								<div className="col-md">
									<DatePicker
										label="Desde"
										onChange={ (text: string) => {
											this.change({
												target: {
													value: text,
													name: 'since'
												}
											},() => this.load(true));
										} }
										value={ this.state.form.since }
									/>
								</div>
								<div className="col-md">
									<DatePicker
										label="Hasta"
										onChange={ (text: string) => {
											this.change({
												target: {
													value: text,
													name: 'until'
												}
											},() => this.load(true));
										} }
										value={ this.state.form.until }
									/>
								</div>
								{
									this.state.companies?.length > 0 && (
										<div className="col-md">
											<Select
												color="white"
												placeholder="Seleccionar"
												label="Empresa"
												name="company_id"
												onChange={ (e: any) => this.change(e,async () => {
													this.load(true);
												}) }
												value={ this.state.form.company_id }
												options={ [
													// @ts-ignore
													{ value: -1, label: this.state.default_company?.name + ' ' + this.state.default_company?.lastname },
													...this.state.companies.map((item: any) => {
														return {
															value: item.id,
															label: item?.name
														}
													})
												] } />
										</div>
									)
								}
								<div className="col-md">
									<Input
										value={ this.state.form.client }
										name="client"
										placeholder="Emisor"
										label="Emisor"
										className="input-table"
										onSubmit={ () => this.load() }
										onChange={ (e: any) => {
											clearTimeout(this.timer);
											this.timer = setTimeout(() => {
												this.load(true);
											},1000);
											this.change(e); 
										} } />
								</div>
								{
									this.props.user?.level_id != Constants.LEVELS.CLIENT && this.props.user?.level_id != Constants.LEVELS.CLIENT_MODERATOR && (
										<div className="col-md">
											<Select
												color="white"
												placeholder="Seleccionar"
												label="Usuario"
												name="client_id"
												onChange={ (e: any) => this.change(e,async () => {
													this.load(true);
												}) }
												value={ this.state.form.client_id }
												options={ this.state.clients.map((item: any) => {
													return {
														value: item.id,
														label: item?.name + ' ' + item?.lastname
													}
												}) } />
										</div>
									)
								}
							</div>
						</div>
						<div className="row">
							<div className="col-md-6"></div>
							<div className="col-md-6 text-right">
								{
									this.state.form != INITIAL_FORM && (
										<button className="btn btn-clean" onClick={ () => this.reset() }>
											<img src={ RestoreIcon } />
											<p>Limpiar</p>
										</button>
									)
								}
							</div>
						</div>
					</div>
				</div>

				<div className="container-totals">
					<div className="row">
						<div className="col-md">
							<div className="item-icon">
								<div className="container-icon" style={{ backgroundColor: '#eff2fc' }}>
									<img src={ MenuIcons.Menu5 } className="blue" />
								</div>
								<div>
									<p className="value-top">Total de facturas</p>
									<p className="value-bottom">{ Globals.formatMiles(this.state.verifications_count,false,'') }</p>
								</div>
							</div>
						</div>
						<div className="col-md">
							<div className="item-icon">
								<div className="container-icon" style={{ backgroundColor: '#ecf9f3' }}>
									<img src={ CheckCircle } className="green" />
								</div>
								<div>
									<p className="value-top">Facturas válidas</p>
									<p className="value-bottom">{ Globals.formatMiles(this.state.approved_count,false,'') }</p>
								</div>
							</div>
						</div>
						<div className="col-md">
							<div className="item-icon">
								<div className="container-icon" style={{ backgroundColor: '#feeeef' }}>
									<img src={ CloseCircle } className="red" />
								</div>
								<div>
									<p className="value-top">Con errores</p>
									<p className="value-bottom">{ Globals.formatMiles(this.state.rejected_count,false,'') }</p>
								</div>
							</div>
						</div>
					</div>
				</div>

				<Table title="Reporte de Facturas" data={ this.state.data.length } header={ this.state.header }
					pagination={
						<Pagination 
							pages={ this.state.last_page } 
							active={ this.state.page }
							onChange={ async (page: number) => {
								await this.setState({
									page: page
								});
								this.load();
							} } />
					}
				>
					{ this.state.data.map((i: any,index: number) => {
						const color: any = this.getColor(i);
						return (
							<tr key={ index } onClick={ () => this.view(i) }>
								{
									this.props.user?.level_id != Constants.LEVELS.CLIENT && this.props.user?.level_id != Constants.LEVELS.CLIENT_MODERATOR && (
										<td>
											{ i.user != null && (
												<div className="container-initial">
													<p className="initial">{ (i?.user?.name + ' ' + i?.user?.lastname).substr(0,1) }</p>
													<p>{ i?.user?.name + ' ' + i?.user?.lastname }</p>
												</div>
											) }	
										</td>
									)
								}
								<td>{ i?.last_verification?.number || '-' }</td>
								<td className="name">{ i?.last_verification?.name || '-' }</td>
								<td>{ moment(i.last_verification?.date).isValid() ? moment(i.last_verification?.date  + ' ' + (i.last_verification?.hour || '')).format('DD/MM/YYYY HH:mm') : '-' }</td>
								<td>{ moment(i.last_verification?.created_at).isValid() ? moment(i.last_verification?.created_at).format('DD/MM/YYYY HH:mm') : '-' }</td>
								{
									this.state.companies?.length > 0 && (
										<td>{ i?.last_verification?.company?.name || (i.user?.name + ' ' + i.user?.lastname) }</td>
									)
								}
								<td>
									<div style={{
										color: color?.color,
										backgroundColor: color?.secondary_color
									}} className="result-container">
										<img src={ color?.icon } />
										{ i?.last_verification?.result_text || '-' }
									</div>
								</td>
							</tr>
						)
					}) }
				</Table>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(BillsReport);